import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getPreMatchCategoryForSport(sportTerm: string) {
  return simpleFetch<KambiCategoryResponse>(
    `${window._kc.apiOfferingBaseUrl}category/pre_match_event,selected_pre_match/sport/${sportTerm}`
  )
}

// =====
// Types
// =====

type KambiCategoryResponse = {
  categoryGroups: KambiCategoryGroup[]
}

type KambiCategoryGroup = {
  categoryGroupName: string
  categories: KambiCategory[]
}

type KambiCategory = {
  id: number
  name: string
  englishName?: string
  sortOrder: number
  displayBoTypeHeaders: boolean
  mappings: KambiCategoryMapping[]
}

type KambiCategoryMapping = {
  criterionId: number
  boType: number
  sortOrder: number
}
